import alt from '../alt';
import modalAction from './modalAction';

class leaveSetAction {
    constructor() {
        this.generateActions(
            'search',
            'processing',
            'staffId',
            'updating',
            'leaveTotalSuccess',
            'totalGain',
            'isSucceed',
            'bringFwd',
            'updateLvTotalSuccess',
            'removeLeaveSuccess',
            'addLeaveSuccess',
            'maxBringFwd',
            'leaveGain',
            'used',
            'userName',
            'holiday',
            'isHolidayUpdated',
        );
    }
    getHoliday(){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/holiday' , true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.holiday(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    updateHoliday(holiday){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/holiday', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Holidays have been successfully updated. Page will refresh in 3 seconds." });
                        modalAction.modalClose(true);
                        this.isHolidayUpdated(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ holiday:holiday}));
        }
        return true;
    }
    getMaxBringFwd(){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/leave/bringFwd' , true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.maxBringFwd(result.bringFwd);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    getLeaveTotal(staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/leave/total/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.leaveTotalSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    updateLeaveTotal(staffId, leaves, maxBringFwd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/leave/total/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        this.updateLvTotalSuccess();
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "The employee's leave has been updated" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ leaves: leaves, bringFwd: maxBringFwd}));
        }
        return true
    }
    removeLeave(type){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("DELETE", '/v1/api/leave/remove', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        this.removeLeaveSuccess(type);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Leave have been removed" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ type: type }));
        }
        return true
    }
    addLeave(leaveTxt, totalGain){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/leave/new', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.addLeaveSuccess(result);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "New Leave Type Added" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ leaveTxt: leaveTxt, totalGain: totalGain }));
        }
        return true
    }
}
export default alt.createActions(leaveSetAction);


// WEBPACK FOOTER //
// ./app/actions/leaveSetAction.js